export default __webpack_public_path__ + "static/media/iconButtonRestaurar.83e2aa55.svg";